/** BlobShip's mark — a rocket with a transparent arrow cut. Inherits color via
 * `currentColor` so it can be tinted (the brand mark is fixed indigo). */
export function BlobShipMark({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <defs>
        <mask id="bsCut" maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
          <rect width="64" height="64" fill="#fff" />
          <path
            d="M32 37V19m0 0-6 6m6-6 6 6"
            transform="rotate(45 32 32)"
            fill="none"
            stroke="#000"
            strokeWidth="3.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
      </defs>
      <path d="M21 43 5 59" fill="none" stroke="currentColor" strokeWidth="4.4" strokeLinecap="round" opacity="0.6" />
      <path d="M21 43 14 56" fill="none" stroke="currentColor" strokeWidth="3.6" strokeLinecap="round" opacity="0.4" />
      <path d="M21 43 8 50" fill="none" stroke="currentColor" strokeWidth="3.6" strokeLinecap="round" opacity="0.4" />
      <g mask="url(#bsCut)">
        <path d="M32 5c9 0 14 12 14 25v11H18V30C18 17 23 5 32 5Z" transform="rotate(45 32 32)" fill="currentColor" />
        <path d="M18 39 9 50h9z" transform="rotate(45 32 32)" fill="currentColor" />
        <path d="M46 39 55 50h-9z" transform="rotate(45 32 32)" fill="currentColor" />
      </g>
    </svg>
  );
}
